import { withNamespaces } from "react-i18next";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

const DataFlowRow = ({
  isDeleteModalOpen,
  handleCloseDeleteModal,
  isDeleting,
  handleConfirmDelete,
  t,
}) => {
  return (
    <Modal isOpen={isDeleteModalOpen} toggle={handleCloseDeleteModal} centered>
      <ModalHeader toggle={isDeleting ? undefined : handleCloseDeleteModal}>
        {t("Confirm Deletion")}
      </ModalHeader>
      <ModalBody>
        {t("Are you sure you want to delete this data flow?")}
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          outline
          onClick={handleCloseDeleteModal}
          disabled={isDeleting}
        >
          {t("Cancel")}
        </Button>
        <Button
          color="danger"
          onClick={handleConfirmDelete}
          disabled={isDeleting}
        >
          {isDeleting ? <Spinner size="sm" /> : t("Delete")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withNamespaces()(DataFlowRow);
